import React from "react";
import styled from "styled-components";
import {
  MainContainer,
  ButtonGroup,
  BackButton,
  StyledForm,
  StyledFormElementsWrapper,
} from "../../ManagementTools/component/styles";
import { Formik } from "formik";
import { Modal, Button } from "@material-ui/core";
import { getErrorMessage } from "../../../../helpers/functions";
import { Heading, HeadingContainer } from "../../../../styles/component/style";
import useLoader from "../../../../hooks/useLoader";
import { useSnackbar } from "notistack";
import NoticeService from "../../../../services/NoticeService";
import { CheckerModalValidationSchema } from "../../../../helpers/validationSchema";
import {
  OptionCheck,
  OptionContainer,
  OptionContent,
  OptionEmail,
  StyledAutocomplete,
} from "../../ManagementTools/component/CustomSelect";
import { CustomInputField } from "../../../common/FormInputs";
import { Label } from "../../ManagementTools/component/SplitAndUpload";

const AssignCheckerModal = ({
  checkerModal,
  setCheckerModal,
  MTRef,
  agents,
  userObject,
}) => {
  const { setLoader } = useLoader();
  const { enqueueSnackbar } = useSnackbar();

  async function onFormSubmit(values) {
    try {
      setLoader({ state: true, message: "Regenerate notice..." });
      const checkerId = parseInt(values?.checkerId) || "";
      const noChecker = true;
      let payload = {
        id: checkerModal?.id,
        ...(!checkerId && { noChecker }),
        ...(checkerId && { checkerId }),
      };
      const response = await NoticeService.bulkNoticeGenerate(payload);
      if (response) {
        enqueueSnackbar(response?.message, {
          variant: "success",
        });
      }
    } catch (err) {
      const error = getErrorMessage(err);
      enqueueSnackbar(error, {
        variant: "error",
      });
    } finally {
      setLoader({ state: false });
      setCheckerModal({ state: false });
      MTRef.current.onQueryChange(MTRef?.current?.state?.query);
    }
  }

  const filteredAgents = [
    ...agents
      .filter(({ partyId }) => partyId === parseInt(checkerModal.partyId))
      .map((agent) => ({
        userId: agent.userId ?? "none",
        email: agent.email ?? "none",
        invitedById: agent.invitedById ?? "none",
      })),
    { userId: "none", email: "none", invitedById: "none" },
  ];

  console.log(filteredAgents, "filteredAgents");

  return (
    <React.Fragment>
      <Modal
        open={checkerModal?.state}
        onClose={() => setCheckerModal({ state: false })}
        disableRestoreFocus
      >
        <DrawerContainer>
          <HeadingContainer>
            <Heading>{"Assign Checker"}</Heading>
            <CloseModal
              onClick={() => setCheckerModal({ state: false })}
              src={require("../../../../assets/images/closeModal.svg")}
            />
          </HeadingContainer>
          <MainContainer style={{ marginTop: 20 }}>
            <Formik
              initialValues={{
                partyId: "",
                checkerId: "",
                userId: userObject?.isRequiredChecker,
              }}
              validationSchema={CheckerModalValidationSchema}
              enableReinitialize
              onSubmit={onFormSubmit}
              validateOnBlur
              validateOnChange
            >
              {({
                values,
                handleChange,
                errors,
                touched,
                handleBlur,
                handleSubmit,
                setFieldValue,
                setFieldError,
                resetForm,
              }) => (
                <StyledForm>
                  <StyledFormElementsWrapper
                    style={{ marginBottom: 15, marginTop: 15 }}
                  >
                    <div className="disabledArrows">
                      <Label>
                        {userObject?.isRequiredChecker
                          ? "Select a checker *"
                          : "Select a checker (Optional)"}
                      </Label>
                      <StyledAutocomplete
                        name="checkerId"
                        fullWidth
                        options={filteredAgents}
                        getOptionLabel={(option) => option.email}
                        isOptionEqualToValue={(option, value) =>
                          option.userId === value?.userId
                        }
                        renderOption={(option) => (
                          <OptionContainer>
                            <OptionContent>
                              <OptionEmail>{option.email}</OptionEmail>
                            </OptionContent>
                            <OptionCheck>✓</OptionCheck>
                          </OptionContainer>
                        )}
                        value={
                          filteredAgents.find(
                            (a) => a.userId === values.checkerId,
                          ) || null
                        }
                        onChange={(e, selected) => {
                          setFieldValue(
                            "checkerId",
                            selected ? selected.userId : null,
                          );
                        }}
                        renderInput={(params) => (
                          <CustomInputField
                            {...params}
                            variant="outlined"
                            error={touched.checkerId && !!errors.checkerId}
                            helperText={touched.checkerId && errors.checkerId}
                          />
                        )}
                      />
                    </div>
                  </StyledFormElementsWrapper>
                  <ButtonGroup>
                    <BackButton
                      onClick={() => setCheckerModal({ state: false })}
                    >
                      Close
                    </BackButton>
                    <SubmitButton
                      onClick={handleSubmit}
                      // disabled={!values?.checkerId}
                    >
                      Submit
                    </SubmitButton>
                  </ButtonGroup>
                </StyledForm>
              )}
            </Formik>
          </MainContainer>
        </DrawerContainer>
      </Modal>
    </React.Fragment>
  );
};

export default AssignCheckerModal;

const DrawerContainer = styled.div`
  max-width: 516px;
  width: 100%;
  background-color: white;
  outline: none;
  position: absolute;
  top: 50%;
  left: 50%;
  border-radius: 10px;
  transform: translate(-50%, -50%);
  padding: 32px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08);
  transition: box-shadow 0.3s ease;
  border: 1px solid #a5bfcc;
`;

const CloseModal = styled.img`
  width: 14px;
  height: 14px;
  object-fit: contain;
  cursor: pointer;
  position: absolute;
  right: 30px;
`;

export const SubmitButton = styled(Button)`
  && {
    background: #0f766e;
    color: #ffffff;
    padding: 10px 24px;
    font-size: 14px;
    font-weight: 600;
    border-radius: 8px;
    border: 1px solid transparent;
    cursor: pointer;
    transition: all 0.3s ease;

    &:hover {
      background: #115e59;
    }

    &.Mui-disabled {
      background: #94a3b8;
      color: #ffffff;
      opacity: 0.6;
      cursor: not-allowed;
    }

    &.Mui-disabled:hover {
      background: #94a3b8;
    }
  }
`;
